export default {
    accountLogin: "Account Login",
    accountNumber: "Account Number",
    password: "Password",
    egateeWebsite: "Egatee Official Website",
    iosDownloadIsNotCurrentlySupportedSoStayTuned: "{0} App does not support the ios version for the time being, so stay tuned!",
    suggestion: "Suggestion",
    downloadBuyerApp: "Download Egatee App",
    aboutUs: "About Us",
    china: "China",
    CoteDivoire: "Côte D'ivoire",
    uganda: "Uganda",
    goDownloadEgateeAPP: "Go Download Egatee App",
    downloadAPP: "Download {0} App",
    downloadAppOnGP: "Go Download {0} App on Google play",
    scanQrCode: "Scan QR code",
    downloadAppOnAppStore: "Go Download {0} App on App Store",
}